export class PlaybackStateChangeEvent extends CustomEvent<{
  playing: boolean;
}> {
  constructor(playing: boolean) {
    super('playbackStateChange', { detail: { playing } });
  }
}
